import React from 'react';
import {
  makeStyles, mergeClasses, shorthands, tokens,
} from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';

const useDescriptionStyles = makeStyles({
  root: {
    backgroundColor: '#eff6fc',
    display: 'flex',
    alignItems: 'flex-start',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
  },
  icon: {
    marginRight: tokens.spacingHorizontalSNudge,
  },
  content: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    ...shorthands.flex(1),
  },
});

interface IInlineCopilotDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

export const InlineCopilotDescription: React.FC<IInlineCopilotDescriptionProps> = React.memo((props) => {
  const styles = useDescriptionStyles();

  return (
    <div className={mergeClasses(styles.root, 'inline-copilot-description', props.className)}>
      <Info16Regular className={styles.icon} />
      <div className={styles.content}>
        {props.children}
      </div>
    </div>
  );
});

InlineCopilotDescription.defaultProps = {
  className: undefined,
};
